import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import {Button} from "react-bootstrap";
import {FormattedMessage} from "react-intl";

const defaultMessage = 'Something went wrong. Try again later...';

const GlobalMessage = ({
                         showGlobalMessage,
                         hideGlobalMessage,
                         message = defaultMessage,
                       }) => {

  return (
    <Modal
      show={showGlobalMessage}
      onHide={hideGlobalMessage}
    >
      <Modal.Body>
        <div className="d-flex flex-column align-items-center justify-content-around">
          <h2 className="font-weight-bold mb-6 text-center">
            {message}
          </h2>
          <Button
            className="custom-send-button pr-5 pl-5"
            onClick={hideGlobalMessage}
          >
            <FormattedMessage
              id="button-close"
              defaultMessage="Close"
            />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
};

GlobalMessage.propTypes = {
  showGlobalMessage: PropTypes.bool,
  hideGlobalMessage: PropTypes.func,
  message: PropTypes.string,
};

export default GlobalMessage;
